//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {
    mapState,
    mapMutations
  } from 'vuex'
  import {
    campaignInfo
  } from '../../service/index'
  export default {
    name: 'countdown',
    data() {
      return {
        camName: ''
      }
    },
    computed: {
      ...mapState(['global', 'campaign']),
    },
    methods: {
      keepLang() {
        let locale = localStorage.locale;
        this.$i18n.locale = locale === 'en' ? locale : 'zh';
      }
    },
    mounted() {
      const camId = this.$route.params.id || this.$route.query.cid
      campaignInfo(camId).then(response => {
        if (response.data) {
          this.camName = response.data.name
        }
      })
      this.keepLang()
    }
  }




// WEBPACK FOOTER //
// ./src/pages/home/End.vue